import type { NotificationInstance } from "antd/es/notification/interface";
import t from "../../app/i18n";
import { numberOrZero } from "./utils";

export class Notification {
  private static notification: NotificationInstance | undefined;

  static init(notification: NotificationInstance) {
    if (this.notification) {
      return;
    }

    this.notification = notification;
  }

  static getNotification() {
    if (!this.notification) {
      throw new Error("AntD Notifications are not initialized!");
    }

    return this.notification;
  }

  static itemCreatedNotification() {
    this.getNotification().success({
      title: t("common.operationSuccess"),
      description: t("common.createOperationSuccess"),
    });
  }

  static itemUpdatedNotification(count?: number) {
    this.getNotification().success({
      title: t("common.operationSuccess"),
      description:
        numberOrZero(count) > 1
          ? t("common.updateOperationSuccessPlural", { count: count })
          : t("common.updateOperationSuccess"),
    });
  }

  static itemDeletedNotification() {
    this.getNotification().success({
      title: t("common.operationSuccess"),
      description: t("common.deleteOperationSuccess"),
    });
  }
}
